import * as Header from '../constants/header.constant'

export interface State {
  title: string
}

export const initialState: State = {
  title: '顧客画面',
}

const header = (state: any = initialState, action: any) => {
  switch (action.type) {
    case Header.HEADER_LOGIN:
      return {
        ...state,
        title: action.payload,
      }
    case Header.HEADER_LOGIN_SUCCESS:
      return {
        ...state,
        title: action.payload,
      }
    case Header.HEADER_REPORT:
      return {
        ...state,
        title: action.payload,
      }
    case Header.HEADER_REPORT_SUCCESS:
      return {
        ...state,
        title: action.payload,
      }
    case Header.HEADER_REPORT_DETAIL_SUCCESS:
      return {
        ...state,
        title: action.payload,
      }
    default:
      return state
  }
}

export default header



// WEBPACK FOOTER //
// ./src/reducers/header.reducer.ts